/**
 * Home Page Component
 * 
 * This is the main landing page for OceanNova.
 * It renders all sections in a structured, maintainable way using
 * a configuration-based approach.
 * 
 * The page structure includes:
 * - Navigation (Navbar)
 * - Hero section
 * - Content sections (Services, Client Success, Global Reach, etc.)
 * - Contact and Footer
 */

import { homeSections } from "@/config/homeSections";
import { SEO } from "@/components/SEO";
import { organizationSchema, websiteSchema, siteNavigationSchema, servicesListSchema } from "@/utils/structuredData";

/**
 * Index page component
 * 
 * Renders all home page sections in order based on the configuration
 * defined in src/config/homeSections.tsx
 */
const Index = () => {
  return (
    <>
      <SEO
        title="OceanNova | Global Freight Forwarding & Shipping"
        description="Professional freight forwarding and shipping agency services with 25+ years of experience. Port operations, ocean freight, air cargo, rail and road logistics, project cargo consulting, and multimodal transport solutions worldwide."
        canonicalPath="/"
        structuredData={[
          organizationSchema,
          websiteSchema,
          siteNavigationSchema,
          servicesListSchema
        ]}
        keywords={["freight forwarding", "shipping agency", "port operations", "project cargo", "intermodal transport", "logistics consulting", "ocean freight", "air cargo", "rail logistics", "road transport"]}
      />
      <div className="min-h-screen page-transition">
        {homeSections.map(({ id, component: Component }) => (
          <Component key={id} />
        ))}
      </div>
    </>
  );
};

export default Index;
